"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceNotAvailableCardCms = void 0;
var ServiceNotAvailableCardCms = /** @class */ (function () {
    function ServiceNotAvailableCardCms() {
        this.ctoLabel = "Call us to order DIRECTV";
        this.differentOptionLabel = "We have a different entertainment option for you";
        this.addressHandlingCTOLabel = "Your address requires special handling. We're here to help.";
        this.directvUnavailableLabel = "DIRECTV isn\u2019t available at this address, but our streaming service,\n    AT&T TV NOW\u2120, is.";
    }
    return ServiceNotAvailableCardCms;
}());
exports.ServiceNotAvailableCardCms = ServiceNotAvailableCardCms;
//# sourceMappingURL=serviceNotAvailableCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/shared/ServiceNotAvailableCard/serviceNotAvailableCard.cms.js
// module id = 1987
// module chunks = 8